import axios from 'axios';

export const BACKEND_URL = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ? 'http://localhost:8000'
  : (process.env.REACT_APP_BACKEND_URL || 'https://pushpanjali.cloud');
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (password) =>
  axios.create({
    baseURL: API,
    headers: { 'X-Admin-Password': password },
  });
